'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';

var Hreflang = function Hreflang(_ref) {
  var href = _ref.href,
      lang = _ref.lang;
  return /*#__PURE__*/_jsx("link", {
    rel: "alternate",
    hrefLang: lang,
    href: href
  });
};

Hreflang.propTypes = {
  href: PropTypes.string.isRequired,
  lang: PropTypes.oneOf(['x-default', 'en', 'de', 'es', 'fr', 'ja', 'pt']).isRequired
};
export default Hreflang;